import classNames         from 'classnames';
import * as React         from 'react';
import { useTranslation } from 'react-i18next';

import './door-preview.style.scss';

import { DoorImage, ZoomPreview } from './components';
import type { DoorPreviewProps }  from './door-preview.props';

const DoorPreview: React.FC<DoorPreviewProps> = function(props) {
  const { t } = useTranslation();

  const {
          zoom,
          isDouble,
          label,
          miniature,
          schema,
          ...rest
        } = props;
  const {
          alt,
          backSideImage,
          backSideImageAlt,
          frontSideImage,
          frontSideImageAlt,
          interiorImage,
          interiorImageAlt,
        } = rest;

  const previewRef = React.useRef<HTMLDivElement | null>(null);

  const [currentSide, setCurrentSide] = React.useState<'inside' | 'outside'>('outside');

  const handleRotate = React.useCallback((event: React.MouseEvent<HTMLSpanElement>) => {
    event.preventDefault();
    event.stopPropagation();

    setCurrentSide((prev) => {
      return prev === 'inside' ? 'outside' : 'inside';
    });
  }, []);

  return (
    <ZoomPreview
      originalRef={previewRef}
      enabled={zoom}
      {...rest}
    >
      <div
        className={classNames('door-preview', {
          'door-double':           isDouble,
          'door-interior':         typeof interiorImage === 'string',
          [`door-${currentSide}`]: isDouble,
        })}
        ref={previewRef}
      >
        {typeof interiorImage === 'string'
          ? (
            <DoorImage
              alt={interiorImageAlt ?? `${alt} ${t('interior')}`}
              productType={t('interior_door')}
              label={label}
              miniature={miniature}
              schema={schema}
              src={interiorImage}
            />
          )
          : (
            <>
              <DoorImage
                alt={frontSideImageAlt ?? `${alt} ${t('outside')}`}
                productType={t('entrance_door')}
                label={label}
                miniature={miniature}
                schema={schema}
                side={t('outside_title')}
                src={frontSideImage}
              />
              <DoorImage
                alt={backSideImageAlt ?? `${alt} ${t('inside')}`}
                productType={t('entrance_door')}
                label={label}
                miniature={miniature}
                schema={schema}
                side={t('inside_title')}
                src={backSideImage}
              />
              {isDouble && !miniature && (
                <span
                  className={'ic-rotate'}
                  onClick={handleRotate}
                />
              )}
            </>
          )
        }
      </div>
    </ZoomPreview>
  );
};

export default DoorPreview;